import { createApi } from '@reduxjs/toolkit/query/react';
import {LoginUrl} from '../../api/endpoints';
import {baseQueryWithReauth} from "../../api/baseQuery";

export const verifyOtpApi= createApi({
  baseQuery: baseQueryWithReauth,
  reducerPath: 'verifyOtpApi',
  endpoints: (builder) => ({
    verifyOtp: builder.mutation({
      query: (initialValues) => ({
        url: LoginUrl,
        method: 'POST',
        body: initialValues,
      }),
    }),
  }),
});

export const { useVerifyOtpMutation } = verifyOtpApi;
